/* eslint-disable default-case */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  IconCheck,
  IconTrashFilled,
} from 'takeat-design-system-ui-kit';
import { useAuth } from '~/context/AuthContext';
import useBarcodeScanner from '~/hooks/useBarcodeScanner';
import toast from 'react-hot-toast';
import ReactSwitch from 'react-switch';
import api from '~/services/api';
import {
  EanArea,
  NoImage,
  ProductArea,
  ProductDescription,
  ProductImage,
  ProductInfo,
  ProductTitle,
  Container,
  InputStyled,
  InputLine,
} from './styles';

export default function Product({ product }) {
  const { user } = useAuth();
  const [isLabelPrinterScaleActive, setIsLabelPrinterScaleActive] = useState();
  const scannedBarcode = useBarcodeScanner();
  const [eanCode, setEanCode] = useState('');
  const [eanCodesArray, setEanCodesArray] = useState([]);
  const [eanCodesLabelArray, setEanCodesLabelArray] = useState([]);
  function toggleIsLabelPrinterScaleActive() {
    setIsLabelPrinterScaleActive(!isLabelPrinterScaleActive);
  }
  const handleAddToEanCodesArray = useCallback(async () => {
    if (eanCode && eanCode !== '') {
      if (isLabelPrinterScaleActive) {
        if (eanCode.length >= 4 && eanCode.length <= 6) {
          let newEan = eanCode;

          for (let index = newEan.length; index < 6; index++) {
            newEan = `${newEan}0`;
          }

          let formattedEan = [];

          switch (user?.ean_scale_mode) {
            case 'price':
              formattedEan = [`$${newEan}`];
              break;
            case 'weight':
              formattedEan = [`#${newEan}`];
              break;
          }

          await api.put(`restaurants/products/${product.id}`, {
            ean_codes: formattedEan,
          });

          setEanCodesLabelArray([newEan]);
          toast.success('Código adicionado com sucesso');
          return;
        }
        toast.error('Informe um código com 4 a 6 dígitos.');
        return;
      }

      if (
        eanCodesArray &&
        eanCodesArray.length > 0 &&
        !isLabelPrinterScaleActive
      ) {
        const eanExist = eanCodesArray?.find((item) => item === eanCode);
        if (eanExist) {
          toast.error('Código já adicionado na lista');
          return;
        }

        await api.put(`restaurants/products/${product.id}`, {
          ean_codes: [...eanCodesArray, eanCode],
        });

        setEanCodesArray((old) => [...old, eanCode]);

        setEanCode('');
        toast.success('Código adicionado com sucesso');
      } else {
        await api.put(`restaurants/products/${product.id}`, {
          ean_codes: [eanCode],
        });

        toast.success('Código adicionado com sucesso');
        setEanCodesArray([eanCode]);
      }
    }
  }, [eanCode, eanCodesArray, user, isLabelPrinterScaleActive, product]);

  async function handleDeleteEanCode(item) {
    try {
      if (isLabelPrinterScaleActive) {
        await api.put(`restaurants/products/${product.id}`, {
          ean_codes: [],
        });

        setEanCodesLabelArray((old) => {
          return old.filter((ean) => ean !== item);
        });

        toast.success('Código removido com sucesso');
      } else {
        await api.put(`restaurants/products/${product.id}`, {
          ean_codes: eanCodesArray.filter((ean) => ean !== item),
        });

        setEanCodesArray((old) => {
          return old.filter((ean) => ean !== item);
        });
        toast.success('Código removido com sucesso');
      }
    } catch (error) {
      toast.error('Erro ao remover código');
    }
  }

  useEffect(() => {
    if (product.ean_codes && product.ean_codes.length > 0) {
      const firstLabel = product.ean_codes[0];
      const hasSymbol =
        typeof firstLabel === 'string' &&
        (firstLabel.startsWith('$') || firstLabel.startsWith('#'));
      if (hasSymbol) {
        setIsLabelPrinterScaleActive(true);
        setEanCodesLabelArray([firstLabel.slice(1)]);
      } else {
        setEanCodesArray(product.ean_codes);
      }
    }
  }, [product]);

  // useEffect(() => {
  //   if (scannedBarcode && scannedBarcode !== '' && !isLabelPrinterScaleActive) {
  //     if (eanCodesArray && eanCodesArray.length > 0) {
  //       const eanExist = eanCodesArray.find((item) => item === scannedBarcode);
  //       if (eanExist) {
  //         toast.error('Código já adicionado na lista');
  //         setEanCode('');
  //         return;
  //       }
  //       setEanCodesArray((old) => [...old, scannedBarcode]);
  //       setEanCode('');
  //     } else {
  //       setEanCodesArray([scannedBarcode]);
  //     }
  //   }
  // }, [scannedBarcode, isLabelPrinterScaleActive]);

  return (
    <Container>
      <ProductArea>
        {product?.image ? (
          <ProductImage
            src={product?.image?.url_thumb || product?.image?.url}
            alt="Foto do produto"
          />
        ) : (
          <NoImage />
        )}

        <ProductInfo>
          <ProductTitle>{product.name}</ProductTitle>
          <ProductDescription>{product.description}</ProductDescription>
        </ProductInfo>
      </ProductArea>
      <EanArea>
        {user.ean_scale_mode !== 'none' && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <ReactSwitch
              label="Ativar código de barra por balança etiquetadora"
              onChange={toggleIsLabelPrinterScaleActive}
              draggable
              checked={isLabelPrinterScaleActive}
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={40}
              handleDiameter={14}
              activeBoxShadow="0 0 2px 3px #111"
              boxShadow="0 0 1px 3px rgba(0,0,0,0.1)"
              onColor="#2EC9B7"
              offColor="#7A7A7A"
            />
            <span
              style={{
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Código de Barras por Balança
            </span>
          </div>
        )}

        {isLabelPrinterScaleActive ? (
          <>
            <InputLine>
              <InputStyled
                name="ean_code"
                placeholder="Escaneie ou digite o Código de Barras"
                onChange={(e) => setEanCode(e.target.value)}
                value={eanCode}
                style={{ width: '100%' }}
              />
              <Button
                icon={<IconCheck />}
                style={{
                  width: 44,
                  height: 44,
                }}
                onClick={handleAddToEanCodesArray}
                type="button"
                customColor="#2EC9B7"
                disabled={
                  isLabelPrinterScaleActive &&
                  eanCodesLabelArray &&
                  eanCodesLabelArray.length > 0
                }
              />
            </InputLine>

            {eanCodesLabelArray && eanCodesLabelArray.length > 0 && (
              <div style={{ marginTop: 24 }}>
                <p style={{ fontWeight: 600, fontSize: 14, color: '#222' }}>
                  Código de barra vinculado
                </p>

                {eanCodesLabelArray &&
                  eanCodesLabelArray.length > 0 &&
                  eanCodesLabelArray.map((item) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <span style={{ fontSize: 14, fontWeight: 400 }}>
                        {item}
                      </span>
                      <IconTrashFilled
                        fill="#C8131B"
                        fontSize={24}
                        onClick={() => handleDeleteEanCode(item)}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  ))}
              </div>
            )}
          </>
        ) : (
          <>
            <InputLine>
              <InputStyled
                name="ean_code"
                placeholder="Escaneie ou digite o Código de Barras"
                onChange={(e) => setEanCode(e.target.value)}
                value={eanCode}
                style={{ width: '100%' }}
              />
              <Button
                icon={<IconCheck />}
                style={{
                  width: 44,
                  height: 44,
                }}
                onClick={handleAddToEanCodesArray}
                type="button"
                customColor="#2EC9B7"
              />
            </InputLine>

            {eanCodesArray && eanCodesArray.length > 0 && (
              <div style={{ marginTop: 24 }}>
                <p style={{ fontWeight: 600, fontSize: 14, color: '#222' }}>
                  Código de barra vinculado
                </p>
                <div>
                  {eanCodesArray &&
                    eanCodesArray.length > 0 &&
                    eanCodesArray.map((item) => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <span style={{ fontSize: 14, fontWeight: 400 }}>
                          {item}
                        </span>
                        <IconTrashFilled
                          fill="#C8131B"
                          fontSize={24}
                          onClick={() => handleDeleteEanCode(item)}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
          </>
        )}
      </EanArea>
    </Container>
  );
}
